// extracted by mini-css-extract-plugin
export default {"giftPointBody":"Message_giftPointBody__tWWYa","okBtn":"Message_okBtn__wjNMM"};